export function registerControllers(controllers) {
  if (!window.Stimulus) throw new Error("Stimulus not found on window!")

  Object.entries(controllers).forEach(([path, mod]) => {
    if (!mod.default) {
      console.warn(`No default export found in ${path}`)
      return
    }

    // e.g. "./drawer_controller.js" → "drawer"
    // e.g. "./subfolder/my_widget_controller.js" → "subfolder--my-widget"
    const name = path
      .replace(/^\.\//, '')            // remove leading ./
      .replace(/_controller\.js$/, '') // remove _controller.js suffix
      .replace(/\//g, '--')            // folders become -- namespace
      .replace(/_/g, '-')              // underscores to dashes (Stimulus convention)

    window.Stimulus.register(name, mod.default)
  })
}
